import { on } from '../helpers/shortcuts';

export default () => {
  const form = document.querySelector('.c-footer__newsletter');

  if (form === null) {
    return;
  }

  let isSubmitting = false;
  const submit = form.querySelector('.c-footer__newsletter-submit');
  const message = form.querySelector('.c-footer__newsletter-message');
  const submitText = submit.textContent;

  on('submit', form, event => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    isSubmitting = true;
    submit.textContent = 'Sending...';

    const formData = new FormData(form);
    const body = {};
    formData.forEach((value, key) => {
      body[key] = value;
    });

    const url = window.APP_DATA.ajax_url;

    message.textContent = '';

    window
      .fetch(url, {
        method: 'POST',
        body: new URLSearchParams({
          ...body,
          action: 'subscribe_newsletter',
        }),
      })
      .then(response => response.json())
      .then(response => {
        submit.textContent = submitText;
        isSubmitting = false;

        if (response.success) {
          form.reset();
        }

        message.textContent = response.data.msg;
      });
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/newsletter.js